import { useState } from 'react';

export function safeBrandingUrl(value) {
  if (typeof value !== 'string' || value.length > 2048 || /[\\\u0000-\u0020\u007f]/.test(value)) return null;
  if (/^\/(?!\/)/.test(value)) return value;
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? value : null;
  } catch { return null; }
}

export default function TenantBrand({ branding, fallback = 'SMM Panel' }) {
  const name = branding?.name || fallback;
  const logo = safeBrandingUrl(branding?.logo_url);
  const [failedLogo, setFailedLogo] = useState(null);
  const logoIdentity = `${name}:${logo}`;
  return <span className="d-inline-flex align-items-center gap-2" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, maxWidth: '100%', minWidth: 0 }}>
    {logo && failedLogo !== logoIdentity && <img src={logo} alt={`${name} logo`}
      style={{ maxWidth: 'min(160px, 40vw)', maxHeight: 48, width: 'auto', height: 'auto', objectFit: 'contain', flexShrink: 0 }}
      onError={() => setFailedLogo(logoIdentity)} />}
    <span style={{ overflowWrap: 'anywhere', whiteSpace: 'normal', minWidth: 0 }}>{name}</span>
  </span>;
}
